// extracted by mini-css-extract-plugin
export default {"orders":"Orders_orders__Lrr7G","center":"Orders_center__nmh4R"};